import { useModuleContext } from '@cognitranlimited/itis-web';
export var gieLinksModuleId = Symbol('gieLinksModule');
export var useGieLinksContext = function () { return useModuleContext(gieLinksModuleId); };
